var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{staticClass:"shadow-2",attrs:{"view":"hHh Lpr lff"}},[_c('q-page-container',[_c('q-page',{},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }